require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./operation-911-misuse-reduction.json") })
        }
      }, "path---operation-911-misuse-reduction");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---operation-911-misuse-reduction!./.cache/json/operation-911-misuse-reduction.json
// module id = 945
// module chunks = 231608221292675